var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCustomLogoOsmand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_custom_logo_osmand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo \xE2\x80\x93 w144, V3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3333 58.1176C53.9519 54.4762 60 45.9444 60 36C60 22.7452 49.2548 12 36 12C22.7452 12 12 22.7452 12 36C12 45.9444 18.0482 54.4762 26.6667 58.1176C31 60 32.6667 61 34 63.6667C34.1298 63.9263 34.2407 64.1734 34.3437 64.4028C34.7695 65.3516 35.0605 66 36 66C36.9395 66 37.2305 65.3516 37.6563 64.4028C37.7593 64.1734 37.8702 63.9263 38 63.6667C39.3333 61 40.878 60 45.3333 58.1176ZM36 49.3334C43.3638 49.3334 49.3334 43.3638 49.3334 36C49.3334 28.6362 43.3638 22.6667 36 22.6667C28.6362 22.6667 22.6667 28.6362 22.6667 36C22.6667 43.3638 28.6362 49.3334 36 49.3334Z",
    fill: "url(#paint0_linear_1558_12356)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1558_12356",
    x1: 36,
    y1: 12,
    x2: 36,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCustomLogoOsmand);
export default __webpack_public_path__ + "static/media/ic_custom_logo_osmand.64e00d2751b598349ee9a564c27d815e.svg";
export { ForwardRef as ReactComponent };